module.exports = __webpack_public_path__ + "static/media/iconfinder_mongodb_1012822.2f0ac8ae.svg";